import styles from "./index.module.css";
const Image = ({
  image,
  breakpoints,
  fit,
  objectPosition,
  width = "100%",
  height = "100%",
  src,
  ...props
}) => {
  if (src)
    return (
      <picture
        className={[
          styles.pictureContain,
          styles[fit],
          styles[objectPosition],
        ].join(" ")}
      >
        <img src={src?.src || src} {...props} />
      </picture>
    );
  let nameProp = breakpoints?.thumbnail ? "thumbnail" : "small";
  breakpoints = {
    ...{ small: "0px", medium: "500px", large: "1000px" },
    ...breakpoints,
    [nameProp]: "0px",
  };

  let sources = image?.formats
    ? Object.keys(image.formats)
        .map((key) => {
          let breakTarget = breakpoints[key] ?? null;
          if (!breakTarget) return null;
          return {
            srcSet: image.formats[key].url,
            media: `(min-width:${breakTarget})`,
            size: Number(breakTarget.replace("px", "")),
          };
        })
        .filter(Boolean)
        .sort((a, b) => b.size - a.size)
    : [];

  return (
    <picture
      style={{ width, height }}
      className={[
        styles.pictureContain,
        styles[fit],
        styles[objectPosition],
      ].join(" ")}
    >
      {sources.map((src,i) => {
        return <source key={'image-'+i} {...src} />;
      })}
      <img src={image?.url} {...props} />
    </picture>
  );
};

export default Image;
